module.exports = __webpack_public_path__ + "img/shift.c8d570dc.svg";